module.exports = __webpack_public_path__ + "static/img/1.3215a63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/1.jpg
// module id = epny
// module chunks = 5